module.exports = __webpack_public_path__ + "img/icon-badges.e8d32386.svg";